import {
    Autocomplete,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    FormControl,
    Typography
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import api from 'api/axios';
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { State, City } from "country-state-city";

const indianStates = State.getStatesOfCountry("IN");
const HospitalModal = ({ open, onClose, medicalFaculties, isEditDoctor }) => {
const { t } = useTranslation();

const style = {
  width: {
    xs: "95%",
    sm: "90%",
    md: "70%",
    lg: "60%",
  },
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 3,
  borderRadius: 2,
};
    const [_id, setID] = useState("");
    const [hospitalName, setHospitalName] = useState("");
    const [hospitalType, setHospitalType] = useState("HOSPITAL");
    const [adminDetails, setAdminDetails] = useState({
        name: "",
        phone: "",
        email: "",
        status: "ACTIVE"
    });
    const [errors, setErrors] = useState({});
    const [, setDoctors] = useState([]);
    const [, setFee] = useState('');
    const [, setDoctor] = useState('');

    const [doctorsList, setDoctorsList] = useState([]);
    const [, setStatus] = useState('');
    const [, setReceptionList] = useState([]);
    const [hospitalAddress, setHospitalAddress] = useState({
        area: "",
        street: "",
        city: "",
        state: "",
        pincode: ""
    });

    const districts = useMemo(() => {
        if (!hospitalAddress.state) return [];
        const stateObj = indianStates.find((s) => s.name === hospitalAddress.state);
        if (!stateObj) return [];
        return City.getCitiesOfState("IN", stateObj.isoCode);
    }, [hospitalAddress.state]);

    useEffect(() => {
        doctorList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        console.log("medicalFaculties data:", medicalFaculties);
    }, [medicalFaculties]);

    useEffect(() => {
        if (medicalFaculties && isEditDoctor) {
            setHospitalName(medicalFaculties?.name);
            setHospitalType(medicalFaculties?.type);
            setHospitalAddress(medicalFaculties?.address);
            const doctors = doctorsList.filter(x => medicalFaculties?.doctors?.includes(x._id));
            setDoctors(doctors);
            setDoctor(medicalFaculties?.doctor);
            setFee(medicalFaculties.fees)
            setStatus(!!(medicalFaculties?.active === 'Active'));
            setID(medicalFaculties?._id);
            setAdminDetails({
                name: medicalFaculties?.hospitalAdmin?.name || "",
                phone: medicalFaculties?.hospitalAdmin?.phone || "",
                email: medicalFaculties?.hospitalAdmin?.email || "",
                status: medicalFaculties?.hospitalAdmin?.status || "ACTIVE",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [doctorsList, medicalFaculties, isEditDoctor]);



    const doctorList = () => {
        try {
            const PayLoadDoctorList = {
                limit: 0,
                page: 1,
            };
            api
                .post(`/admin/doctors-list`, PayLoadDoctorList)
                .then((res) => {
                    const DOCTOR = res?.data?.data?.doctorList.filter(x => x?.role?.type === 'DOCTOR');
                    const RECEPTION = res?.data?.data?.doctorList.filter(x => x?.role?.type === 'RECEPTION');
                    setDoctorsList(DOCTOR || [])
                    setReceptionList(RECEPTION || [])
                })
                .catch((err) => {
                    const errorMessage = err?.response?.data?.message || err.message || "An error occurred";
                    toast.error(errorMessage);
                });
        } catch (error) {
            toast.error(`Error ${error}`);
        }
    };
    const handleAdminChange = (e) => {
        const { name, value } = e.target;
        setAdminDetails((prev) => ({
            ...prev,
            [name]: value
        }));
        const errorKey = {
            name: "adminName",
            phone: "adminPhone",
            email: "adminEmail"
        };
        setErrors((prev) => ({
            ...prev,
            [errorKey[name]]: ""
        }));
    };

    const validateForm = () => {
        let newErrors = {};
        if (!hospitalName.trim()) {
            newErrors.hospitalName = "Hospital name is required";
        }
        if (!hospitalAddress.area.trim()) {
            newErrors.area = "Address is required";
        }
        if (!hospitalAddress.state.trim()) {
            newErrors.state = "State is required";
        }
        if (!hospitalAddress.city.trim()) {
            newErrors.city = "District is required";
        }
        if (!hospitalAddress.pincode.match(/^[0-9]{6}$/)) {
            newErrors.pincode = "Valid 6 digit pincode required";
        }
        if (!adminDetails.name.trim()) {
            newErrors.adminName = "Admin name required";
        }
        if (!adminDetails.phone.match(/^[0-9]{10}$/)) {
            newErrors.adminPhone = "Valid 10 digit phone required";
        }
        if (!adminDetails.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
            newErrors.adminEmail = "Valid email required";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmitHospital = () => {
    if (!validateForm()) return;
    try {
        const hospitalPayload = {
            name: hospitalName,
            type: hospitalType,
            ...(isEditDoctor && _id ? { _id } : {}),
            address: hospitalAddress,
            adminDoctor: {
                name: adminDetails.name,
                phone: adminDetails.phone,
                email: adminDetails.email,
                status: adminDetails.status || "ACTIVE"
            }
        };
        api
            .post(`/hospital/medicalFaclty`, hospitalPayload)
            .then(() => {
                onClose();
                toast.success(isEditDoctor ? "Hospital Updated" : "Hospital Created");
            })
            .catch((err) => {
                const errorMessage = err?.response?.data?.message || err.message || "An error occurred";
                toast.error(errorMessage);
            });

    } catch (error) {
        toast.error(`Error ${error}`);
    }
};
const handleHospitalAddress = (e) => {
    const { name, value } = e.target;

    setHospitalAddress((prev) => ({
        ...prev,
        [name]: value
    }));

    setErrors((prev) => ({
        ...prev,
        [name]: ""
    }));
};

    return (
        <div>
            <Modal
                open={open}
                onClose={() => onClose("close")}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Box sx={style}>
                    <Grid
                        container
                        spacing={2}
                        display="flex"
                        justifyContent="left"
                        sx={{ mb: 3 }}>
                        <Grid item>
                            <Typography variant="h5" component="h5" align="center">
                                {isEditDoctor ? t('EDIT_MEDIAL_FAC') : t('CREATE_MEDIAL_FAC')}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems="center">
                        <Grid item sm={12} lg={6} md={6}>
                            <TextField
                                fullWidth
                                type={"text"}
                                value={hospitalName}
                                label="Hospital Name"
                                name="name"
                                required
                                onChange={(e) => {
                                    setHospitalName(e.target.value);
                                    setErrors((prev) => ({ ...prev, hospitalName: "" }));
                                }}
                                size="small"
                                error={!!errors.hospitalName}
                                helperText={errors.hospitalName}
                            />
                        </Grid>
                        <Grid item sm={12} lg={6} md={6}>
                            <FormControl fullWidth sx={{ minWidth: 120 }} size="small">
                                <InputLabel id="clinic-type">
                                    Type
                                </InputLabel>
                                <Select
                                    size="small"
                                    labelId="clinic-type"
                                    id="clinic-type-deoctor"
                                    value={hospitalType}
                                    disabled
                                    label="Doctor Status"
                                    onChange={(e) => setHospitalType(e.target.value)}>
                                    <MenuItem value={'HOSPITAL'}>Hospital</MenuItem>
                                    <MenuItem value={'CLINIC'}>Clinic</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item sm={12} lg={6} md={6}>
                            <TextField
                                fullWidth
                                type={"text"}
                                value={hospitalAddress.area}
                                label="Hospital Address"
                                name="area"
                                onChange={handleHospitalAddress}
                                size="small"
                                required
                                error={!!errors.area}
                                helperText={errors.area}
                            />
                        </Grid>
                        <Grid item sm={12} lg={6} md={6}>
                            <Autocomplete
                                size="small"
                                options={indianStates}
                                getOptionLabel={(option) => option.name || option}
                                value={
                                    indianStates.find((s) => s.name === hospitalAddress.state) || null
                                }
                                onChange={(_, newValue) => {
                                    setHospitalAddress((prev) => ({
                                        ...prev,
                                        state: newValue?.name || "",
                                        city: "",
                                        pincode: "",
                                    }));
                                    setErrors((prev) => ({ ...prev, state: "", city: "", pincode: "" }));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="State"
                                        required
                                        size="small"
                                        error={!!errors.state}
                                        helperText={errors.state}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item sm={12} lg={6} md={6}>
                            {districts.length === 0 && hospitalAddress.state ? (
                                <TextField
                                    fullWidth
                                    label="District / City"
                                    name="city"
                                    value={hospitalAddress.city}
                                    onChange={(e) => {
                                        setHospitalAddress((prev) => ({ ...prev, city: e.target.value }));
                                        setErrors((prev) => ({ ...prev, city: "" }));
                                    }}
                                    size="small"
                                    required
                                    placeholder="Enter district name"
                                    error={!!errors.city}
                                    helperText={errors.city || "No districts found, type manually"}
                                />
                            ) : (
                            <Autocomplete
                                size="small"
                                options={districts}
                                getOptionLabel={(option) => option.name || option}
                                disabled={!hospitalAddress.state}
                                value={
                                    districts.find((d) => d.name === hospitalAddress.city) || null
                                }
                                onChange={(_, newValue) => {
                                    setHospitalAddress((prev) => ({
                                        ...prev,
                                        city: newValue?.name || "",
                                    }));
                                    setErrors((prev) => ({ ...prev, city: "" }));
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="District / City"
                                        required
                                        size="small"
                                        placeholder={
                                            hospitalAddress.state
                                                ? "Search district..."
                                                : "Select state first"
                                        }
                                        error={!!errors.city}
                                        helperText={errors.city}
                                    />
                                )}
                            />
                            )}
                        </Grid>
                        <Grid item sm={12} lg={6} md={6}>
                            <TextField
                                fullWidth
                                type={"text"}
                                value={hospitalAddress.pincode}
                                label="Pincode"
                                name="pincode"
                                onChange={(e) => {
                                    e.target.value = e.target.value.replace(/\D/g, "").slice(0, 6);
                                    handleHospitalAddress(e);
                                }}
                                size="small"
                                error={!!errors.pincode}
                                helperText={errors.pincode}
                                required
                            />
                        </Grid>                        
                        <Grid item xs={12}>
                            <Typography variant="h6">Hospital Admin Details</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                label="Admin Name"
                                name="name"
                                value={adminDetails.name}
                                onChange={handleAdminChange}
                                error={!!errors.adminName}
                                helperText={errors.adminName}
                                size="small"
                                required
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            fullWidth
                            label="Admin Phone"
                            name="phone"
                            value={adminDetails.phone}
                            onChange={(e) => {
                                e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
                                handleAdminChange(e);
                            }}
                            error={!!errors.adminPhone}
                            helperText={errors.adminPhone}
                            size="small"
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        fullWidth
                        label="Admin Email"
                        name="email"
                        value={adminDetails.email}
                        onChange={handleAdminChange}
                        error={!!errors.adminEmail}
                        helperText={errors.adminEmail}
                        size="small"
                        required
                    />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl fullWidth size="small">
                        <InputLabel id="admin-status-label">Status</InputLabel>
                        <Select
                            labelId="admin-status-label"
                            label="Status"
                            name="status"
                            value={adminDetails.status}
                            onChange={handleAdminChange}
                            >
                            <MenuItem value="ACTIVE">ACTIVE</MenuItem>
                            <MenuItem value="INACTIVE">INACTIVE</MenuItem>
                        </Select>
                        </FormControl>
                        </Grid>
                        <Grid
                            item
                            sm={12}
                            lg={12}
                            md={12}
                            display="flex"
                            justifyContent="right">
                            <Button variant="contained" onClick={handleSubmitHospital}>
                                {t('SUBMIT')}
                            </Button>
                            <Button
                                sx={{ marginLeft: "5px" }}
                                variant="contained"
                                onClick={() => onClose('close')}>
                                {t('CANCEL')}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
};

export default HospitalModal;
